import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import Partners from './components/Partners';
import Header from './components/Header';
import Games from './components/Games';
import BuyPage from './components/BuyPages/BuyPage';
import ArbBuyPage from './components/BuyPages/ArbBuyPage';
import SolBuyPage from './components/BuyPages/SolBuyPage';
import EvmBuyPage from './components/BuyPages/EvmBuyPage';

/** Scroll to top on page change, or to the #section when the URL has a hash (e.g. "/#faq"). */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = hash.slice(1);
    const t = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
    return () => window.clearTimeout(t);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollManager />
      <div className="flex min-h-screen flex-col">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/memefi" element={<Partners />} />
            <Route path="/buy" element={<BuyPage />} />
            <Route path="/games" element={<Games />} />
            <Route path="/buy/arbitrum" element={<ArbBuyPage />} />
            <Route path="/buy/solana" element={<SolBuyPage />} />
            <Route path="/buy/cex" element={<Navigate to="/buy" replace />} />
            <Route path="/buy/evm" element={<EvmBuyPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
